import React from 'react';
import ChatBox from 'src/components/custom/Editor/ChatBox';
import { useAppDispatch, useAppSelector } from 'src/store';
import { useClassTopicContent } from 'src/hooks';
import { createDiscussion } from 'src/thunks/discussion';
import discussion from 'src/store/model/discussion';

const DiscussionForm: React.FC = () => {
  const { class_topic_content_id, class_id, content } = useClassTopicContent();
  const dispatch = useAppDispatch();
  const currentUser = useAppSelector((state) => state.ui.app.me);

  return (
    <div className="">
      <ChatBox
        placeholder={
          'Write a post, type @ to mention people, \nTip: Add a timestamp e.g 2:02 to your notes for quick access to specific parts of the module video'
        }
        onSend={(html) => {
          const payload = {
            message: html,
            user: currentUser as Model.User,
            user_id: currentUser?.id,
            class_topic_content_id,
            class_id,
            class_topic_id: content.class_topic_id,
          };

          dispatch(discussion.createDummy(payload));
          dispatch(createDiscussion(payload));
        }}
      />
    </div>
  );
};

export default DiscussionForm;
